module.exports = __webpack_public_path__ + "hopper.png?79dc21d2f88e066d00c09dbc68a1b554";